import React from "react";
import { Consumer, FlashActionProviderInterface } from "./Context";

type WithFlashMessagesProps<P> = Omit<P, "flashMessages">;

export default function withFlashMessages<P extends object>(
    WrappedComponent: React.ComponentType<P & { flashMessages: FlashActionProviderInterface | null }>
): React.FC<WithFlashMessagesProps<P>> {
    return (props: WithFlashMessagesProps<P>) => (
        <Consumer>
            {(flashMessages) => (
                <WrappedComponent {...(props as P)} flashMessages={flashMessages} />
            )}
        </Consumer>
    );
}
